<script setup lang="ts">
import IconMaterialSymbolsWarningRounded from '~icons/material-symbols/warning-rounded'
import { computed } from 'vue'
import { confirmState } from '@/shared/components/confirm/confirm'

// Components
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog'
import Button from '@/shared/components/Button.vue'
import Icon from '@/shared/components/Icon.vue'

const open = computed(() => confirmState.value !== null)

const onAccept = () => {
  const state = confirmState.value
  confirmState.value = null
  state?.accept?.()
}

const onReject = () => {
  const state = confirmState.value
  confirmState.value = null
  state?.reject?.()
}

const onOpenChange = (isOpen: boolean) => {
  if (!isOpen) onReject()
}
</script>

<template>
  <AlertDialog
    :open="open"
    @update:open="onOpenChange"
  >
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ confirmState?.header }}</AlertDialogTitle>
        <AlertDialogDescription class="flex items-start gap-3">
          <Icon
            class="h-5 w-5 shrink-0"
            severity="warning"
            :icon="IconMaterialSymbolsWarningRounded"
          />
          <span class="whitespace-pre-line">{{ confirmState?.message }}</span>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button
          v-if="!confirmState?.hideReject"
          :label="confirmState?.rejectLabel ?? 'Cancel'"
          text
          @click="onReject"
        />
        <Button
          :label="confirmState?.acceptLabel ?? 'Confirm'"
          :severity="confirmState?.acceptSeverity ?? 'primary'"
          @click="onAccept"
        />
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
